import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'pink-lava-ui';
import type { TooltipPlacement } from 'antd/es/tooltip';

interface ConditionalTooltipProps {
  title: string;
  placement: TooltipPlacement;
  children: React.ReactNode;
  className?: string;
}

const ConditionalTooltip: React.FC<ConditionalTooltipProps> = ({ title, placement, children, className }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const checkTruncation = () => {
    const element = textRef.current;
    if (element) {
      setShowTooltip(element.scrollWidth > element.clientWidth);
    }
  };

  useEffect(() => {
    checkTruncation();
  }, [title]);

  useEffect(() => {
    const handleResize = () => {
      checkTruncation();
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const content = (
    <div ref={textRef} className={className}>
      {children}
    </div>
  );

  return showTooltip ? (
    <Tooltip placement={placement} title={title}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default ConditionalTooltip;
